export const getBrowser = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Edg")) {
    return "Other";
  } else if (
    userAgent.includes("Chrome") &&
    navigator.userAgent.includes("Macintosh")
  ) {
    return "Chrome";
  } else if (
    userAgent.includes("Safari") &&
    navigator.userAgent.includes("Macintosh")
  ) {
    return "Safari";
  } else if (userAgent.includes("Chrome")) {
    return "Chrome";
  } else {
    return "Other";
  }
};

export const getBrowserPermissionSteps = (type = "camera") => {
  const browser = getBrowser();
  const stepsByBrowser = {
    Chrome: [
      "Click the 🎚️ slider icon to the left of the address bar",
      `In the menu that appears, find ${
        type === "camera" ? "Camera" : "Microphone"
      } or "Permissions".`,
      `Set ${type === "camera" ? "Camera" : "Microphone"} to "Allow".`,
      'Change the setting to "Allow".',
      "If prompted, refresh the page to apply changes.",
    ],
    Safari: [
      "Click Safari in the top menu and choose 'Settings for This Website...'.",
      `Find ${type} in the dropdown list and choose 'Allow'.`,
      `Or go to Safari > Preferences > Websites > ${type}, and set permission to Allow.`,
      "Refresh the page.",
    ],
    Other: [
      "Click the 🔒 padlock icon to the left of the address bar",
      `In the menu that appears, find ${
        type === "camera" ? "Camera" : "Microphone"
      } or "Permissions".`,
      `Set ${type === "camera" ? "Camera" : "Microphone"} to "Allow".`,
      'Change the setting to "Allow".',
      "If prompted, refresh the page to apply changes.",
    ],
  };

  const steps = stepsByBrowser[browser] || stepsByBrowser.Other;
  const formattedSteps = steps.map((step, i) => `${i + 1}. ${step}`).join("\n");

  return formattedSteps;
};
